import { render, staticRenderFns } from "./updateCustomChannelContent.vue?vue&type=template&id=74bf99be&"
import script from "./updateCustomChannelContent.vue?vue&type=script&lang=js&"
export * from "./updateCustomChannelContent.vue?vue&type=script&lang=js&"
import style0 from "./updateCampaignContent.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports